import { User as Auth0User } from '@auth0/auth0-spa-js/dist/typings/global';

import { ILoginDetailsUser } from '../../shared/models/user';

const isSchneiderEmployeesEmail = (email: string): boolean => {
  return email.includes('@non.se.') || email.includes('@se.') || email.includes('@feller.');
}

export const getUserFederatedId = (user: Auth0User): string => {
  return user.sub?.replace('auth0|', '');
}

export const mapToAddToAnalyticsUser = (user: Auth0User): ILoginDetailsUser => {
  return {
    companyId: user['https://id.feller.ch/user_metadata']?.company_details?.headquarter?.uid,
    companyName: user['https://id.feller.ch/user_metadata']?.company_details?.headquarter?.name,
    isSchneiderEmployee: isSchneiderEmployeesEmail(user.email),
    userId: getUserFederatedId(user),
    customerClassificationCategory: user['https://id.feller.ch/user_metadata']?.iama?? ''
  }
}
